import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MenuController, NavController, ModalController } from '@ionic/angular';
import { IUser } from 'src/app/models/user.interface';
import { AuthService } from 'src/app/services/guard/auth.service';
import { UserService } from 'src/app/services/user.service';
import { AccountService } from 'src/app/services/account.service';
import { environment } from 'src/environments/environment';
import { IAccount } from 'src/app/models/account.interface';
import { PostTypeHelperModalComponent } from 'src/app/modals/post-type-helper-modal/post-type-helper-modal.component';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss'],
  standalone: false
})
export class NavMenuComponent implements OnInit {


  pages = [
    {
      title: 'Home',
      url: '/home',
      class: 'users',
      icon: './assets/icon/menu/dark/home.svg'
    },
    {
      title: 'Help me decide...',
      url: '',
      action: 'helpMeDecide',
      class: 'users',
      group: 'Create',
      icon: './assets/icon/menu/dark/help-buoy.svg'
    },
    {
      title: 'Wordpress Post',
      url: '/post-wordpress-new',
      class: 'wordpress',
      group: 'Create',
      icon: './assets/icon/menu/dark/logo-wordpress.svg'
    },
    {
      title: 'Social Card Post',
      url: '/post-new',
      class: 'users',
      group: 'Create',
      icon: './assets/icon/menu/dark/social-card.svg',
      queryParams: { postType: 'social-card' }
    },
    {
      title: 'Photo Post',
      url: '/post-new',
      class: 'users',
      group: 'Create',
      icon: './assets/icon/menu/dark/image.svg',
      queryParams: { postType: 'photo' }
    },
    {
      title: 'Text Post',
      url: '/post-new',
      class: 'users',
      group: 'Create',
      icon: './assets/icon/menu/dark/create.svg',
      queryParams: { postType: 'text' }
    },
    /*
    {
      title: 'Blog Post',
      url: '/blog-new',
      class: 'wordpress-blog',
      group: 'Create',
      icon: './assets/icon/menu/dark/logo-wordpress.svg'
    },
    */
    {
      title: 'Aggregate Feed',
      url: '/aggregate-feed',
      class: 'users',
      group: 'Feed',
      icon: './assets/icon/menu/dark/list-circle.svg'
    },
    {
      title: 'Publish History',
      url: '/history',
      class: 'users',
      group: 'Feed',
      icon: './assets/icon/menu/dark/history.svg'
    },
    {
      title: 'Reports',
      url: '/reports',
      class: 'users',
      group: 'Feed',
      icon: './assets/icon/menu/dark/bar_chart.svg'
    },
    {
      title: 'Accounts',
      url: '/accounts',
      class: 'command-center',
      group: 'Accounts',
      icon: 'apps'
    },
    {
      title: 'Connect',
      url: '/settings/connect',
      class: 'owner',
      group: 'Settings',
      icon: './assets/icon/menu/dark/connections.svg'
    },
    {
      title: 'AI Tuning',
      url: '/settings/ai-tuning',
      class: 'users',
      group: 'Settings',
      icon: './assets/icon/menu/dark/tuning-fork.svg'
    },
    {
      title: 'Social Card',
      url: '/settings/image-template',
      class: 'users',
      group: 'Settings',
      icon: './assets/icon/menu/dark/images.svg'
    },
    {
      title: 'User Management',
      url: '/settings/user-management',
      class: 'business',
      group: 'Settings',
      icon: './assets/icon/menu/dark/people.svg'
    },
    {
      title: 'Account Settings',
      url: '/settings/account',
      class: 'users',
      group: 'Settings',
      icon: './assets/icon/menu/dark/person-circle.svg'
    },
    {
      title: 'API & MCP Access',
      url: '/settings/api-access',
      class: 'owner-or-admin',
      group: 'Settings',
      icon: './assets/icon/menu/dark/smart-toy.svg'
    },
    {
      title: 'Admin Dashboard',
      url: '/admin/dashboard',
      class: 'admin',
      group: 'Admin',
      icon: './assets/icon/menu/dark/shield.svg'
    },
    {
      title: 'System Logs',
      url: '/admin/logs',
      class: 'admin',
      group: 'Admin',
      icon: './assets/icon/menu/dark/shield.svg'
    },
    {
      title: 'Aggregate Feed',
      url: '/admin/aggregate-feed',
      class: 'admin',
      group: 'Admin',
      icon: './assets/icon/menu/dark/shield.svg'
    },
    {
      title: 'AI Activity',
      url: '/admin/ai-activity',
      class: 'admin',
      group: 'Admin',
      icon: './assets/icon/menu/dark/shield.svg'
    },
    /*
    {
      title: 'Sign Up',
      url: '/signup',
      class: 'unauthenticated',
      icon: './assets/icon/menu/dark/person-add-outline.svg'
    },
    {
      title: 'Log In',
      url: '/login',
      class: 'unauthenticated',
      icon: './assets/icon/menu/dark/log-in.svg'
    },
    */
  ];


  login = false;
  user: IUser;
  account: IAccount
  isDev = false;
  visibleClasses: Set<string> = new Set();
  accountImage: string = null;
  isMenuExpanded = true;
  isSelectingAccount = false;
  private subs: Subscription[] = [];


  constructor(public auth: AuthService,
    private navCtrl: NavController,
    public menuCtrl: MenuController,
    private userService: UserService,
    private accountService: AccountService,
    private modalCtrl: ModalController) { }


  ngOnInit() {
    const userSub = this.auth.fetchUser().subscribe((user) => {
      this.user = user;

      this.updateVisibleMenu();

      // Recalculate which image to show (account preferred)
      this.setAccountImage();
    });
    this.subs.push(userSub);

    this.isDev = !environment.production;

    // Subscribe to active account so the menu shows the account logo when available
    const acctSub = this.accountService.activeAccountObservable().subscribe(acct => {
      this.account = acct;
      // Recompute menu visibility as publishTargets may depend on active account
      this.updateVisibleMenu();
      this.setAccountImage();
    });
    this.subs.push(acctSub);
    

    // Subscribe to account-selection mode to disable navigation while selecting
    const selectingSub = this.accountService.selectingAccountObservable().subscribe(v => {
      this.isSelectingAccount = !!v;
    });
    this.subs.push(selectingSub);
  }

  private getUserId(): string | null {
    if (!this.user || !this.user._id) return null;
    return this.user._id.toString();
  }

  private isOwner(): boolean {
    if (!this.user || !this.account || !this.user._id || !this.account.ownerId) return false;
    return this.account.ownerId.toString() === this.user._id.toString();
  }

  private isOwnerOrAdmin(): boolean {
    if (!this.user || !this.account || !this.user._id) return false;
    const userIdStr = this.user._id.toString();
    if (this.account.ownerId && this.account.ownerId.toString() === userIdStr) return true;
    return (this.account.members || []).some(
      m => (m.userId as any)?.toString() === userIdStr && (m.role === 'admin' || m.role === 'owner')
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
    this.subs = [];
  }

  private setAccountImage() {
    // Prefer account logo
    const acctLogo = this.accountService.getAccountLogoUrl(this.account);
    if (acctLogo) {
      this.accountImage = acctLogo;
      return;
    }

    // Fall back to user logo
    if (this.user?.logo) {
      this.accountImage = this.userService.getUserLogoUrl(this.user._id, this.user.logo);
      return;
    }

    // No logo available
    this.accountImage = null;
  }




  /**
   * On view reentry
   */
  updateVisibleMenu() {
    // Reset visible classes
    this.visibleClasses.clear();

    if (!this.user || !this.user.roles?.length) {
      this.visibleClasses.add('unauthenticated');
    } else {
      if (this.user.roles.includes('user')) this.visibleClasses.add('users');
      if (this.user.roles.includes('business')) this.visibleClasses.add('business');
      if (this.user.roles.includes('admin')) this.visibleClasses.add('admin');

      if (this.account?.isBusiness) {
        this.visibleClasses.add('business');
      }

      // Owner-only menu items
      if (this.isOwner()) {
        this.visibleClasses.add('owner');
      }

      // Owner or Admin menu items (e.g. API & MCP Access)
      if (this.isOwner() || this.isOwnerOrAdmin() || this.user.roles.includes('admin')) {
        this.visibleClasses.add('owner-or-admin');
      }

      // Handle special cases
      this.applySpecialCases();
    }
  }


  applySpecialCases() {
    // Add users class if user exists
    if (this.user) {
      this.visibleClasses.add('users');
    }

    if (this.account?.publishTargets?.wordpress) {
      this.visibleClasses.add('wordpress');
    }
    if (this.account?.publishTargets?.wordpress?.plugins?.includes('blog_post')) {
      this.visibleClasses.add('wordpress-blog');
    }

    // Add admin class if user has admin role
    if (this.user?.roles?.includes('admin')) {
      this.visibleClasses.add('admin');
    }

    // Check command center access (same as switch account access)
    if (this.hasCommandCenterAccess) {
      this.visibleClasses.add('command-center');
    }
  }

  get hasCommandCenterAccess(): boolean {
    const roles: string[] = this.user?.roles ?? [];
    const hasRoleAccess = Array.isArray(roles) && (roles.includes('pro') || roles.includes('admin'));
    const hasLevelAccess = this.user?.userLevel === 'pro';
    return hasRoleAccess || hasLevelAccess;
  }

  /**
   * Helper function to check if there are any valid publish targets
   * @returns 
   */
  hasValidPublishTargets(): boolean {
    const publishTargets = this.account?.publishTargets;
    if (!publishTargets) return false;
    return Object.entries(publishTargets).some(([key, target]) => !!target);
  }



  isPageVisible(pageClass: string): boolean {
    if (this.isSelectingAccount) return false; // hide navigation while selecting/creating account
    return this.visibleClasses.has(pageClass);
  }



  /**
   * Helper method for groups to simplify the HTML
   * @returns 
   */
  getGroups(): string[] {
    return [...new Set(
      this.pages
        .filter(page => page.group && this.isPageVisible(page.class))
        .map(page => page.group)
    )];
  }


  isGroupVisible(group: string): boolean {
    if (group === 'Create' || group === 'Feed') {
      // Only show Create and Feed groups if the user has publish targets
      return this.hasValidPublishTargets();
    }

    if (group === 'Admin') {
      // Only show Admin group if the user is an admin
      return this.user?.roles?.includes('admin') ?? false;
    }

    if (group === 'Settings') {
      // Always show Settings group
      return true;
    }

    return true; // Default to show for other groups
  }


  toggleMenu() {
    this.isMenuExpanded = !this.isMenuExpanded;
    const menu = document.querySelector('ion-menu');
    if (menu) {
      menu.classList.toggle('collapsed', !this.isMenuExpanded);
    }
  }


  async handlePageClick(page: any) {
    if (page.action === 'helpMeDecide') {
      this.close();
      await this.openHelpMeDecide();
    } else {
        this.close();
    }
  }

  async openHelpMeDecide() {
    // Determine if user has wordpress target (logic similar to applySpecialCases check)
    const hasWordpress = this.account?.publishTargets?.wordpress ? true : false;
    
    const modal = await this.modalCtrl.create({
      component: PostTypeHelperModalComponent,
      componentProps: {
        hasWordpressTarget: hasWordpress
      }
    });
    return await modal.present();
  }


  /**
   * Close menu
   */
  close() {
    this.menuCtrl.close('mainMenu');
  }


  /**
   * Logout
   */
  async logout() {
    await this.auth.logout();
    await this.navCtrl.navigateRoot('/login');
    this.menuCtrl.close('mainMenu');
  }

}
